import { render, staticRenderFns } from "./StoreMap.vue?vue&type=template&id=2064eda8&"
import script from "./StoreMap.vue?vue&type=script&lang=js&"
export * from "./StoreMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports